// client/src/Services/api.js
import axios from "axios";

// Cria instância do Axios com base na URL do .env
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_API.endsWith("/")
    ? process.env.REACT_APP_API_URL_API
    : `${process.env.REACT_APP_API_URL_API}/`,
  timeout: 15000, // 15 segundos de timeout
});

// Intercepta respostas e erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Mostra no console apenas em desenvolvimento
    if (process.env.NODE_ENV === "development") {
      console.error("Erro na API:", error);
    }
    return Promise.reject(error);
  }
);

export default api;
